<template>
    <div class="hstack gap-1">
        <slot name="label">{{ label }}</slot>
        <Multiselect :model-value="modelValue"
                        :options="items"
                        mode="single"
                        :close-on-select="true"
                        :label="'text'"                        
                        :searchable="true"
                        :filter-results="true"
                        :strict="false"
                        :submit="false"
                        :native-support="true"
                        :classes="{
                            tag: 'bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1'
                        }"
                        @update:model-value="$emit('update:modelValue', $event)">                        
        </Multiselect>
    </div>
</template>
<script setup lang="ts">
import Vue from "vue";
import { defineComponent, ref, watch, defineEmits } from 'vue';
import type { PropType } from 'vue';
import Multiselect from '@vueform/multiselect'
import {
    BFieldSelection
} from "../BFilterEditor/BFilterEditor.types";


        const props = defineProps<{
            items: BFieldSelection[],
            disabled: boolean,
            modelValue: string,
            label: string
        }>()

        defineEmits<{
            (event: 'update:modelValue', value: string): void
        }>();     
        
</script>